//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MortgageDetails from "./mortgage-details.vue";
import Property from "./property.vue";
import { ObserveVisibility } from "vue-observe-visibility";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MortgageAndProperty",
  components: {
    MortgageDetails,
    Property
  },
  directives: {
    ObserveVisibility
  },
  props: {
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleSave() {
      this.$emit("save");
    },
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleReplicate() {
      this.$emit("replicate");
    },
    handleVisibilityChange(isVisible, key) {
      if (isVisible) {
        this.$emit("page-change", key, {
          scrollTop: false
        });
      }
    }
  }
});